import {
    isValidElement,
    type ReactNode
} from "react";
import type {
    CodeViewerLayoutConstantType,
    CodeViewerPartKind,
    CodeViewerLayout
} from "./type";
import {
    flattenCardChildren
} from "../card/util";

export const CODE_VIEWER_PART_KINDS: Array<CodeViewerPartKind> = [
    "actions",
    "header",
    "footer",
    "title"
];

const isCodeViewerPartKind = (value: unknown): value is CodeViewerPartKind => {
    return typeof value === "string" && CODE_VIEWER_PART_KINDS.some((kind) => kind === value);
};

export const getCodeViewerPartKind = (node: ReactNode): CodeViewerPartKind | undefined => {
    if(!isValidElement(node)) {
        return undefined;
    }

    const elementType: unknown = node.type;

    if(typeof elementType !== "function" && (typeof elementType !== "object" || elementType === null)) {
        return undefined;
    }

    if(!("codeViewerPart" in elementType)) {
        return undefined;
    }

    return isCodeViewerPartKind(elementType.codeViewerPart) ? elementType.codeViewerPart : undefined;
};

export const getCodeViewerLayout = ({
    children
}: CodeViewerLayoutConstantType): CodeViewerLayout => {
    const nodes = flattenCardChildren(children);

    return {
        footers: nodes.filter((node) => getCodeViewerPartKind(node) === "footer"),
        headers: nodes.filter((node) => getCodeViewerPartKind(node) === "header"),
        body: nodes.filter((node) => {
            const kind = getCodeViewerPartKind(node);

            return kind !== "header" && kind !== "footer";
        })
    };
};
